import './../../index.css';
import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import hoc from '../../hoc.js';
import 'classnames';
import '@hh.ru/magritte-common-use-disabled';
import '@hh.ru/magritte-ui-badge';
import '../../IconDynamic-BiKz7_SZ.js';
import '../../Skeleton.js';
import '@hh.ru/magritte-ui-skeleton';

const PinFilledSize16Component = (props, ref) => (jsx("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref: ref, ...props, children: jsx("path", { d: "M9.3361 14.3271C9.25568 14.4241 9.17041 14.5178 9.08041 14.6078L8.35868 15.3295L5.01094 11.9818L1.5 15.5L0.5 14.5L4.02099 10.9919L0.666606 7.63747L1.38888 6.9152C1.47874 6.82541 1.57227 6.74032 1.66909 6.66006C2.55041 5.92948 3.70439 5.59899 4.84919 5.76255L6.19526 5.95485L9.46234 2.68774L8.26043 1.48583L9.25016 0.496094L15.5 6.74593L14.5103 7.73567L13.3082 6.53399L10.0413 9.80089L10.2336 11.147C10.3972 12.2918 10.0667 13.4457 9.3361 14.3271Z", fill: "var(--magritte-ui-icon-color)" }) }));
const PinFilledSize16 = hoc(forwardRef(PinFilledSize16Component), 'PinFilledSize16');

export { PinFilledSize16 as default };
//# sourceMappingURL=PinFilledSize16.js.map
